module.exports = __webpack_public_path__ + "assets/media/chrome-notif.5ae38065.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/ExtensionPreview/chrome-notif.png
// module id = 2049
// module chunks = 0